module.exports = __webpack_public_path__ + "img/validation-new-active.46e93e15.svg";